/**
 * Colorful drawing/art icon for "Drawing Tools".
 * Pencil + paintbrush + dabs of color — conveys creative drawing.
 */
export default function DrawingIcon({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Pencil — diagonal, top-left to bottom-right */}
      {/* wooden shaft */}
      <polygon
        points="6,22 11,17 22,6 25,9 14,20 9,25"
        fill="#fde68a"
        stroke="#92400e"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      {/* metal ferrule */}
      <polygon
        points="11,17 14,20 17,17 14,14"
        fill="#cbd5e1"
        stroke="#475569"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      {/* eraser */}
      <polygon
        points="14,14 17,17 19,15 16,12"
        fill="#fb7185"
        stroke="#9f1239"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      {/* pencil tip */}
      <polygon
        points="6,22 9,25 7,27 5,25"
        fill="#1f2937"
        stroke="#0f172a"
        strokeWidth="1"
        strokeLinejoin="round"
      />

      {/* Color dabs scattered around */}
      <circle cx="25" cy="22" r="2.6" fill="#0284c7" />
      <circle cx="28" cy="27" r="1.8" fill="#16a34a" />
      <circle cx="22" cy="28" r="2.0" fill="#db2777" />
      <circle cx="3" cy="6" r="1.6" fill="#f59e0b" />
      <circle cx="7" cy="3" r="1.2" fill="#7c3aed" />
    </svg>
  );
}
